import api from './api';

const BASE = '/moncash-fees';

export default {
  list: (kind) =>
    api.get(BASE, { params: { functionCode: 'MONCASH_FEE_VIEW', kind } }).then(r => r.data),

  save: (kind, rules) =>
    api.put(
      BASE,
      { rules, functionCode: 'MONCASH_FEE_UPDATE' },
      { params: { kind } }
    ).then(r => r.data),
};